import React from "react";
import {Form} from "antd";
import IContainerOptions from "../../../../../../model/interface/form/elementOptions/IContainerOptions";
import IContentType from "../../../../../../model/interface/dataStorage/IContentType";
import IframeWidgetEditor from "../../../widget/optionEditor/IframeWidgetEditor";
import FieldPicker from "../../../../../shared/pickers/FieldPicker";
import IFormIframeOptions from "../../../../../../model/interface/form/elementOptions/IFormIframeOptions";

interface IProps {
    options: IFormIframeOptions,
    contentType: IContentType
}

class IFrameEditor extends React.Component<IProps> {

    render() {
        const {options, contentType} = this.props

        return (
            <>
                <IframeWidgetEditor {...this.props} disabledUrl={!!options.field}/>
                <Form.Item name={'field'} label={'Zvolte pole ako zdroj url'}>
                    <FieldPicker serviceClassName={contentType.fullClassName} mode={"tree"} output={'name'}/>
                </Form.Item>
            </>
        )
    }
}

export default IFrameEditor